// Bundled translations — eliminates HTTP latency and build-time fetch issues.
// English

import { NAMESPACES } from "./namespaces";
import enErrors from "./namespaces/en/errors.json";
import enFeatures from "./namespaces/en/features.json";
import enInputs from "./namespaces/en/inputs.json";
import enUi from "./namespaces/en/ui.json";
// Spanish
import esErrors from "./namespaces/es/errors.json";
import esFeatures from "./namespaces/es/features.json";
import esInputs from "./namespaces/es/inputs.json";
import esUi from "./namespaces/es/ui.json";
// Korean
import koErrors from "./namespaces/ko/errors.json";
import koFeatures from "./namespaces/ko/features.json";
import koInputs from "./namespaces/ko/inputs.json";
import koUi from "./namespaces/ko/ui.json";
// Chinese (Simplified)
import zhErrors from "./namespaces/zh/errors.json";
import zhFeatures from "./namespaces/zh/features.json";
import zhInputs from "./namespaces/zh/inputs.json";
import zhUi from "./namespaces/zh/ui.json";
import { registerBundle } from "./registry";

registerBundle({
  ns: NAMESPACES.UI,
  resources: { en: enUi, es: esUi, zh: zhUi, ko: koUi },
});
registerBundle({
  ns: NAMESPACES.INPUTS,
  resources: { en: enInputs, es: esInputs, zh: zhInputs, ko: koInputs },
});
registerBundle({
  ns: NAMESPACES.ERRORS,
  resources: { en: enErrors, es: esErrors, zh: zhErrors, ko: koErrors },
});
registerBundle({
  ns: NAMESPACES.FEATURES,
  resources: { en: enFeatures, es: esFeatures, zh: zhFeatures, ko: koFeatures },
});
